import React, { useEffect, useState } from "react";
import { renderToString } from 'react-dom/server';
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import ApplicationBar from "../modules/ui/ApplicationBar";
import { getOneInByClave, postIn } from "../../services/crudCustom";
import { GroupUserData } from "../modules/ui/GroupUserData";
import { SelectCustomWithOther } from "../modules/ui/SelectCustomWithOther";
import { Grid, Paper, TextField } from "@mui/material";
import { SelectCustom } from "../modules/ui/SelectCustom";
import { InputNumber } from "../modules/ui/InputNumber";
import Swal from "sweetalert2";
import { generateRef } from "../../helpers/generateRef";
import { setEmailBodyConfirm } from "../../helpers/setEmailBodyConfirm";
import moment from "moment";
import QRCode from 'qrcode';
import { ButtonSubmit } from "../modules/ui/ButtonSubmit";
import { GroupUserWork } from "../modules/ui/GroupUserWork";
import { SelectCountryAndRegion } from "../modules/ui/SelectCountryAndRegion";
import { MuiDatePicker } from "../modules/ui/MuiDatePicker";
import { valFormValues } from "../validators/valFormValues";
import { SendingDialog } from "../modules/dialogs/SendingDialog";
import { sendEmail } from "../../services/sendEmail";
import { processUserWorks } from "../../services/processUserWorks";
import { CustomDialog } from "../modules/dialogs/CustomDialog";



const drawerWidth = 200;
const drawerOptions = ["Datos personales", "Datos profesionales", "Datos SIMAC", "Tipo de participación", "Concurso de tesis"];


export const Simac = () => {

    // state para los valores del evento
    const [event, setEvent] = useState({ 
        id: "",
        claveProyecto: "",
        tituloEvento: "",
        urlLogo: "",
        tabla: "",
        solicitudFolio: "",
        correoEvento: "",
    });
    const { 
        tituloEvento,
        urlLogo,
        correoEvento,
    } = event;

    // State para el tipoParticipacionOptions
    const [tipoParticipacionOptions, setTipoParticipacionOptions] = useState([
    //    {value:'Ponente_online', label:'Presentando uno o más trabajos (línea) [ unicamente aquellos previamente registrados ]'},
        {value:'Asistente_online', label:'Como asistente (línea)'},
        // {value:'Ponente', label:'Presentando uno o más trabajos'},
        // {value:'Asistente', label:'Como asistente'},
        // {value:'Organizador', label:'En la organización del evento'},
    ]);

    // State para los valores del formulario
    const [formValues, setFormValues] = useState({
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partGenero: "",
        partNacionalidad: "",
        partTelefono: "",
        
        profInstitucion: "",
        profDireccion: "",
        profPais: "",
        profEstado: "",
        profGrado: "",
        profOcupacion: "",

        simacMiembro: "",
        simacDesde: "",
        simacTipoMembresia: "",
        simacFormarParte: "",
        simacRecibirInformacion: "",

        tipoRegistro: "",
        totalTrabajos: "",
        trabajos: [],
        
        concursoParticipa: "",
        concursoCategoria: "",
        concursoAsesorApellidoPaterno: "",
        concursoAsesorApellidoMaterno: "",
        concursoAsesorNombres: "",
        concursoAsesorCorreo: "",
        concursoAsesorInstitucion: "",
        concursoAsesorTelefono: "",
        concursoAsesorMiembro: "",

        claveProyecto: "",
        registroFecha: "",
        registroReferencia: "",

        requiereFactura: "",
        factNombre: "",
        factRFC: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        factExtranjero: "",
        factExtPais: "",
        factExtNombre: "",
        factExtConcepto: "",
        factExtUsoCFDI: "",
        compPagoFecha: "",
        compPagoURLLabel: "",
        compPagoURL: "",        
    });
    const {
        partCorreo,
        partGenero,
        partNacionalidad,
        partTelefono,

        profInstitucion,
        profDireccion,
        profGrado,
        profOcupacion,

        simacMiembro,
        simacTipoMembresia,
        simacFormarParte,
        simacRecibirInformacion,

        tipoRegistro,
        totalTrabajos,
        trabajos,

        concursoParticipa,
        concursoCategoria,
        concursoAsesorInstitucion,
        concursoAsesorTelefono,
        concursoAsesorMiembro,

        registroReferencia,
    } = formValues;

    // state para el codigo QR
    const [src, setSrc] = useState({ qrdata:"" });

    // state para saber si es miembro simac
    const [esMiembro, setEsMiembro] = useState(-1);

    // state para saber si es ponente
    const [esPonente, setEsPonente] = useState(false);

    // state para saber si participa en el concurso
    const [esConcursante, setEsConcursante] = useState(false);
    
    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);


    // Drawer ---
    // Index del item a mostrar, inicia en 0, al cargar se muestra el primero
    const [selectedItem, setSelectedItem] = useState(0);
    // Al seleccionar un item del Drawer se establece el index seleccionado
    const handleDrawerSelectedItem = (index) => {
        setSelectedItem(index);
    }
    // ---


    // Al cambiar un input tipo texto de uno de los trabajos
    const handleWorkInputChange = ({target}) => {
        const { name, value } = target;
        // En name obtenemos el nombre del input tipo texto y su indice
        console.log(name, value);
        
        // Lo que se ingrese se almacena en el elemento correcto del array 'trabajos'
        const itemName = name.slice(0, name.indexOf("-"));
        const itemIndex = name.slice(name.indexOf("-")+1, name.length) - 1;
        // console.log(itemName, itemIndex);
        trabajos[itemIndex][itemName] = value;

        setFormValues({
            ...formValues,
            trabajos: trabajos,
        });
    }


    // Al cambiar el numero de los autores
    const handleWorkTotalAutoresChange = ({workIndex, trabAutores}) => {

        trabajos[workIndex].trabAutores = trabAutores;

        setFormValues({
            ...formValues,
            // trabajos[workIndex].trabAutores: trabAutores,
        });
    }
    

    // Mostrar los inputs dependiendo si es o no miembro SIMAC
    const handleMiembroSIMACChange = ({ target }) => {
        const { name, value } = target;

        console.log(name, value);
        setFormValues({
            ...formValues,
            [name]: value,
        });

        // if (value === 'Si') {}
        switch (value) {
            case 'Si':
                setEsMiembro(1);
                break;
            case 'No':
                setEsMiembro(0);
                break;
            default:
                break;
        }
    }


    // Mostrar los inputs dependiendo el tipo de participacion seleccionada
    const handleTipoParticipacionChange = ({ target }) => {
        const { name, value } = target;

        console.log(name, value);
        setFormValues({
            ...formValues,
            [name]: value,
        });

        // Ponente_online

        // if (value === 'Ponente') {
        if (value === 'Ponente' || value === 'Ponente_online') {
            setEsPonente(true);
        } else {
            setEsPonente(false);
        }
    }


    // Mostrar los inputs dependiendo si participa o no en el concurso
    const handleConcursoParticipaChange = ({target}) => {
        const { name, value } = target;

        console.log(name, value);
        setFormValues({
            ...formValues,
            [name]: value,
        });

        if (value === 'Si') {
            setEsConcursante(true);
        } else {
            setEsConcursante(false);
        }
    }


    // Al modificar el numero de trabajos
    const handleTotalTrabajosChange = ({ target }) => {
        const { name, value } = target;

        // console.log(name, value);
        setFormValues({
            ...formValues,
            [name]: value,
        });

        const { trabajos } = formValues;

     // Agrega un trabajo con la estructura completa
     if (value > trabajos.length) {
            // Crear nuevo trabajo
            const newTrab = { 
                trabModalidad: '', 
                trabNumParticipaciones: '1',
                trabTitulo: '', 
                trabOrientacion: '', 
                trabPalabrasClave: '', 
                trabNumAutores: '1',
                trabAutores: [{
                    autorNombres:'',
                    autorApellidos:'',
                    autorProcedencia:'',
                    autorEmail:'',
                }],
                trabResumenURL: '', 
                trabResumenURLLabel: '', 
                trabResumenTexto: ''
            };
            // Agregar trabajo
            trabajos.push(newTrab);
        } else {
            // Eliminar ultimo trabajo
            trabajos.pop();
        }
    }


    // Cada que cambia el pais y estado
    const handleProfessionCountryAndRegionChange = ({ country, region }) => {
        // console.log(country, region);
        setFormValues({
            ...formValues,
            profPais: country,
            profEstado: region,
        })
    }


    // Al modificar un dato en un input
    const handleInputChange = ({ target }) => {
        const { name, value } = target;

        console.log(name, value);

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }



    // Procesamiento de la info
    const isDataProcessed = async() => {
        console.log("Processing data");

        // En este punto ya se validó que es ponente con trabajos y estan capturados correctamente

        // Subir los trabajos 
        let trabajosProcessed = [];
        if (tipoRegistro === 'Ponente' || tipoRegistro === 'Ponente_online') {
            const resultProcessUserWorks = await processUserWorks({ trabajos, registroReferencia });
            console.log({ resultProcessUserWorks });

            // Hubo error? return false para notificar usuario y mandar correo al dev
            if (resultProcessUserWorks.sucess !== 1) { return false; }

            trabajosProcessed = resultProcessUserWorks.data;
            setFormValues({
                ...formValues,
                trabajos: trabajosProcessed
            });
        }
        
        // Configura lo que se va a escribir a la base de datos
        const valuesFormated = {
            ...formValues,
            trabajos: JSON.stringify(trabajosProcessed)
        }

        // - Grabar en la base de datos
        const resultPost = await postIn({ table:event.tabla, values:valuesFormated });
        console.log({resultPost});
        // Hubo error? return false para notificar usuario y mandar correo al dev
        if (resultPost.exito !== 1) { return false; }

        // - Armar el correo de acuse y enviarlo
        const urlConfirma = `${process.env.REACT_APP_HOMEPAGE}/confirmar-registro/${registroReferencia}`;
        const urlVisualiza = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${registroReferencia}`;
        
        // - Data adicional, para enlaces
        const aditionalData = 
        "<h3>información adicional:</h3>" +
        "<ul>" +
        `Puede consultar los detalles de su registro en <a href=${urlVisualiza}>este enlace</a> o escaneando el codigo QR` +
        "</ul>";
        
        const eventValues = { tituloEvento, urlConfirma, urlVisualiza, urlLogo, aditionalData };
        
        const msgbody = renderToString( setEmailBodyConfirm({ formValues, eventValues, src }) );

        // - Se genera el cc
        let toccAddresses = (process.env.REACT_APP_TOBCC_FACTURACION !== '') ? event.correoEvento : '';

        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": `[${tituloEvento}] CIBNOR`,
            "message": msgbody,
            "replyto": correoEvento,
            "tocc": toccAddresses,
        });
        console.log({emailResult});

        return true;
    }


    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {

        // Mostrar waiting dialog 
        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 

        // Ocultar waiting dialog 
        setSendingForm(false);

        // Dependiendo el resultado se notifica al usuario...
        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ver más eventos',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                }
            }); 
        } else {
            // Notificar del error al usuario y enviar email a developer
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedió un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente en 12 horas.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 
            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": `Error [${event.tituloEvento}]`,
                "message": `resultDataProcessed: ${resultDataProcessed} | formValues: ` + formValues,
            });
        }
    }


    // Al enviar formulario
    const handleSubmit = async (event) => {
        event.preventDefault();

        // TODO: Validar los inputs en un componente aparte
        const validationResult = valFormValues({ formValues });
        console.log({validationResult});

        // Si la validacion no pasa, salte
        if ( !validationResult ) { return false; }


        // Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                // procesar data
                continueConfirmed();
            }
        })

    }
    

    useEffect(() => {
        
        // Al cargarse la pagina se ejecuta este codigo una sola vez
        const setInitialValues = async() => {

            // Indicamos que item del Drawer se muestra, para agilizar las pruebas
            // setSelectedItem(2);

            // No tiene proyecto, se le asigna clave de 5 digitos del teclado telefonico SIMAC = 74622
            const PROY_RECURSOS = '74622';

            // +++ Recuperamos el evento y asignamos valores
            const resultProyDataLoaded = await getOneInByClave({ table:'EventosConRegistro', clave:PROY_RECURSOS });
            // console.log({resultProyDataLoaded});

            // No existe el proyecto y muestra mensaje
            if (resultProyDataLoaded.exito === 0) {
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: "Evento no disponible",
                    text: "Comuniquese a inscripciones@cibnor.mx para mayor información.",
                    confirmButtonText: 'Catálogo de eventos',
                    icon: 'warning',
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                    }
                }); 
            }
            const ProyData = resultProyDataLoaded.data[0];
            // Asignamos los valores al state
            setEvent({ ...ProyData });

            // Titulo de la pagina / pestaña
            document.title = `[${ProyData.tituloEvento}] CIBNOR`;

            // +++ Asignamos valores
            // Se genera la referencia incluyendo el proyecto
            const resultGenerateRef = generateRef({ prefix:PROY_RECURSOS });
            // Obtenemos el dato para el campo 'fechaRegistro'
            const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');
            // console.log(dateNow);

            // const dateA = moment([2023, 0, 29]).format('YYYY-MM-DDTHH:mm:ss');
            const dateA = moment("2023-03-07T09:00:00").format('YYYY-MM-DDTHH:mm:ss');
            const dateB = moment("2023-03-07T13:00:00").format('YYYY-MM-DDTHH:mm:ss');
            // console.log(dateA);

            // Dependiendo la fecha y hora asignamos las opciones disponibles
            if (dateNow > dateA && dateNow < dateB) {
                setTipoParticipacionOptions([
                   {value:'Ponente_online', label:'Presentando uno o más trabajos (línea) [ unicamente aquellos previamente registrados ]'},
                    {value:'Asistente_online', label:'Como asistente (línea)'},
                ]);
            } 

            
            // Asignamos los valores al state
            setFormValues({
                ...formValues,
                claveProyecto: PROY_RECURSOS,
                registroFecha: dateNow,
                registroReferencia: resultGenerateRef,
            })

            // +++ Generamos el QR
            const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${resultGenerateRef}`;
            QRCode.toDataURL( qrString )
            .then( (data) => {
                setSrc( { qrdata:data } );
            })


        };
        setInitialValues();

    }, [ ])
    

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex" }} autoComplete="off">
            <CssBaseline />
            
            <AppBar 
                position="fixed" 
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            >
                <ApplicationBar
                title={`${event.tituloEvento} - Registro en línea`} 
                subtitle=""
                logo={event.urlLogo}
                logoVariant="square"
            />
            </AppBar>

            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
                }}
            >
                <Toolbar />
                <Box sx={{ overflow: "auto" }}>
                    <List>
                        {drawerOptions.map((text, index) => (
                            <ListItem key={text} disablePadding>
                                <ListItemButton onClick={ () => (handleDrawerSelectedItem(index)) }>
                                    <ListItemText primary={text} /> { (index === selectedItem) ? '•': '' }
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                    <Divider />
                </Box>
            </Drawer>

            {/* Contenido del item seleccionado */}
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />

                {/* Datos personales  */}
                <Grid container sx={{ display:(selectedItem === 0) ? 'flex' : 'none' }}>
                    <h5>Datos personales</h5>
                    <GroupUserData parentCallback={handleInputChange}
                        title='' 
                        userEmail='partCorreo' 
                        userEmailLabel='Correo electrónico *' 
                        userFatherName='partApellidoPaterno' 
                        userFatherNameLabel='Apellido Paterno *' 
                        userMotherName='partApellidoMaterno' 
                        userMotherNameLabel='Apellido Materno' 
                        userName='partNombres' 
                        userNameLabel='Nombre(s) *' 
                        variant='outlined' 
                    />

                    {/* Genero */}
                    <SelectCustomWithOther parentCallback={handleInputChange}
                        name={"partGenero"}
                        label={"Género *"}
                        options={[
                            {value:'Masculino', label:'Masculino'},
                            {value:'Femenino', label:'Femenino'},
                        ]}
                        paddingH={2}
                        paddingV={1}
                        value={partGenero}
                        variant='outlined' 
                    />

                    {/* Nacionalidad */}
                    <Grid container spacing={2} sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                id="partNacionalidad"
                                label={`Nacionalidad *`}
                                name="partNacionalidad"
                                size="small"
                                value={partNacionalidad}
                                onChange={handleInputChange}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>

                    {/* Telefono */}
                    <InputNumber
                        parentCallback={handleInputChange}
                        defaultValue={''}
                        inputProps={{ 
                            min: 1, 
                        }}
                        label={'Teléfono *'}
                        name={'partTelefono'}
                        paddingH={2}
                        paddingV={1}
                        value={partTelefono}
                        variant={'outlined'}
                        xs={6}
                    />
                </Grid>

                {/* Datos profesionales  */}
                <Grid container sx={{ display:(selectedItem === 1) ? 'flex' : 'none' }}>
                    <h5>Datos profesionales</h5> 

                    {/* Institucion */}
                    <Grid container spacing={2} sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                id="profInstitucion"
                                label={`Institución *`}
                                name="profInstitucion"
                                onChange={handleInputChange}
                                size="small"
                                value={profInstitucion}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>

                    {/* Direccion institucional */}
                    <Grid container spacing={2} sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}>
                        <Grid item xs={12} >
                            <TextField
                                fullWidth
                                id="profDireccion"
                                label={`Dirección institucional *`}
                                name="profDireccion"
                                onChange={handleInputChange}
                                size="small"
                                value={profDireccion}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>

                    {/* Pais y estado */}
                    <SelectCountryAndRegion parentCallback={handleProfessionCountryAndRegionChange} 
                        paddingH={2}
                        paddingV={1}
                        variant="outlined" 
                    />

                    {/* Grado */}
                    <Grid item xs={4} >
                        <SelectCustom 
                            parentCallback={handleTipoParticipacionChange}
                            name={"profGrado"}
                            label={"Grado: *"}
                            options={[
                                {value:'Lic', label:'Licenciatura'},
                                {value:'MC', label:'Maestría'},
                                {value:'Dr', label:'Doctorado'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={profGrado}
                            variant='outlined' 
                        />
                    </Grid>
                    
                    {/* Ocupacion / puesto */}
                    <SelectCustomWithOther parentCallback={handleInputChange}
                        name={"profOcupacion"}
                        label={"Ocupación / puesto *"}
                        options={[
                            {value:'Estudiante Licenciatura', label:'Estudiante Licenciatura'},
                            {value:'Estudiante Maestría', label:'Estudiante Maestría'},
                            {value:'Estudiante Doctorado', label:'Estudiante Doctorado'},
                            {value:'Posdoctorado', label:'Posdoctorado'},
                            {value:'Investigador', label:'Investigador'},
                            {value:'Profesional', label:'Profesional'},
                        ]}
                        paddingH={2}
                        paddingV={1}
                        value={profOcupacion}
                        variant='outlined' 
                    />

                </Grid>

                {/* Datos SIMAC */}
                <Grid container sx={{ display:(selectedItem === 2) ? 'flex' : 'none' }}>
                    <Grid item xs={12} >
                        <h5>Datos SIMAC</h5> 
                    </Grid>

                    {/* Miembro SIMAC */}
                    <SelectCustom 
                        parentCallback={handleMiembroSIMACChange}
                        name={"simacMiembro"}
                        label={"¿Miembro SIMAC? *"}
                        options={[
                            {value:'Si', label:'Si'},
                            {value:'No', label:'No'},
                        ]}
                        paddingV={1}
                        paddingH={2}
                        value={simacMiembro}
                        variant='outlined' 
                    />

                    <Grid container spacing={0} sx={{ display:(esMiembro === 1) ? 'flex' : 'none' }}>
                        {/* Miembro desde */}
                        <MuiDatePicker 
                            parentCallback={handleInputChange}
                            name={"simacDesde"} 
                            label={"Miembro desde *"} 
                            paddingV={1}
                            paddingH={2}
                        />
                        {/* Tipo de Membresía */}
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"simacTipoMembresia"}
                            label={"Tipo de Membresía *"}
                            options={[
                                {value:'Estudiantes', label:'Estudiantes'},
                                {value:'Honorarios', label:'Honorarios'},
                                {value:'Regulares', label:'Regulares'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={simacTipoMembresia}
                            variant='outlined' 
                        />
                    </Grid>

                    <Grid container spacing={0} sx={{ display:(esMiembro === 0) ? 'flex' : 'none' }}>
                        {/* Formar Parte SIMAC */}
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"simacFormarParte"}
                            label={"¿Quieres formar parte de la SIMAC? *"}
                            options={[
                                {value:'Si', label:'Si'},
                                {value:'No', label:'No'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={simacFormarParte}
                            variant='outlined' 
                        />
                    </Grid>

                    {/* Recibir Informacion */}
                    <SelectCustom 
                        parentCallback={handleInputChange}
                        name={"simacRecibirInformacion"}
                        label={"¿Te gustaría recibir información de la SIMAC al correo electrónico? *"}
                        options={[
                            {value:'Si', label:'Si'},
                            {value:'No', label:'No'},
                        ]}
                        paddingV={1}
                        paddingH={2}
                        value={simacRecibirInformacion}
                        variant='outlined' 
                    />

                </Grid>


                {/* Tipo de participacion  */}
                <Grid container sx={{ display:(selectedItem === 3) ? 'flex' : 'none' }}>
                    <h5>Tipo de participación</h5>
                    <SelectCustom 
                        parentCallback={handleTipoParticipacionChange}
                        name={"tipoRegistro"}
                        label={"Participará: *"}
                        options={ tipoParticipacionOptions }
                        // options={[
                        //     {value:'Ponente_online', label:'Presentando uno o más trabajos (línea) [ unicamente aquellos previamente registrados ]'},
                        //     {value:'Asistente_online', label:'Como asistente (línea)'},
                        //     // {value:'Ponente', label:'Presentando uno o más trabajos'},
                        //     // {value:'Asistente', label:'Como asistente'},
                        //     // {value:'Organizador', label:'En la organización del evento'},
                        // ]}
                        paddingV={1}
                        value={tipoRegistro}
                        variant='outlined' 
                    />

                    {/* Grid si es ponente */}
                    <Grid container sx={{ display:(esPonente) ? 'flex' : 'none' }}>

                        {/* ¿Cuantos trabajos?  */}
                        <InputNumber
                            parentCallback={handleTotalTrabajosChange}
                            defaultValue={null}
                            inputProps={{ 
                                min: 1, 
                                onKeyDown: (event) => {
                                    event.preventDefault();
                                }
                            }}
                            label={'¿Cuantos trabajos? *'}
                            name={'totalTrabajos'}
                            paddingH={0}
                            paddingV={1}
                            value={totalTrabajos}
                            variant='outlined'
                            xs={6}
                        />

                        {/* El conjunto de trabajos */}
                        {trabajos.map((text, index) => (
                            <ListItem key={index} disablePadding>
                                <Paper elevation={2} sx={{ mb: 2 }}>
    
                                    <GroupUserWork 
                                        parentCallback={handleWorkInputChange}
                                        workTitle={`trabTitulo-${index + 1}`} 
                                        workTitleLabel={`Título del trabajo ${index + 1} *`}
                                        workTitleHelper={`Indicar los nombres científicos entre #, ejemplo: #NombreCientifico#`}
                                        // orientationCallback={handleWorkInputChange}
                                        workOrientation={`trabOrientacion-${index + 1}`} 
                                        workOrientationLabel={`Orientación del trabajo ${index + 1} *`} 
                                        workOrientationOptions={[
                                            {value:'Taxonomía y colecciones científicas', label:'Taxonomía y colecciones científicas'},
                                            {value:'Sistemática y biogeografía', label:'Sistemática y biogeografía'},
                                            {value:'Genética y evolución', label:'Genética y evolución'},
                                            {value:'Desarrollo y morfofisiología', label:'Desarrollo y morfofisiología'},
                                            {value:'Comportamiento y ecología', label:'Comportamiento y ecología'},
                                            {value:'Bioseguridad (inocuidad y sanidad acuícola)', label:'Bioseguridad (inocuidad y sanidad acuícola)'},
                                            {value:'Biología pesquera', label:'Biología pesquera'},
                                            {value:'Piscicultura', label:'Piscicultura'},
                                            {value:'Ictiología aplicada', label:'Ictiología aplicada'},
                                            {value:'Conservación y manejo', label:'Conservación y manejo'},
                                        ]} 
                                        workModality={`trabModalidad-${index + 1}`} 
                                        workModalityLabel={`Modalidad del trabajo ${index + 1} *`} 
                                        workModalityOptions={[
                                            {value:'Ponencia Oral', label:'Ponencia Oral'},
                                            {value:'Póster', label:'Póster'},
                                        ]} 
                                        workNumParticipaciones={`trabNumParticipaciones-${index + 1}`}
                                        workNumParticipacionesLabel={`Número de participaciones *`}
                                        
                                        workResume={`trabResumenTexto-${index + 1}`}
                                        workResumeLabel={`Resumen del trabajo ${index + 1} *`}
                                        workResumeHelper={`Palabras restantes disponibles: `}
                                        workResumeMaxWordsCount={300}
                                        workKeywords={`trabPalabrasClave-${index + 1}`}
                                        workKeywordsLabel={`Palabras clave *`}
                                        workKeywordsHelper={`Máximo tres palabras clave separadas por comas`}
                                        autoresCallback={handleWorkTotalAutoresChange}
                                        workNumAutores={`trabNumAutores-${index + 1}`}
                                        workNumAutoresLabel={`Número de autores *`}
                                        variant={'filled'}
                                    />
    
                                </Paper>
                            </ListItem>
                        ))}

                    </Grid>

                </Grid>


                {/* Concurso de tesis */}
                <Grid container sx={{ display:(selectedItem === 4) ? 'flex' : 'none' }}>
                    <Grid item xs={12} >
                        <h5>Concurso de tesis</h5> 
                    </Grid>
                    {/* Concurso de tesis */}
                    <SelectCustom 
                        parentCallback={handleConcursoParticipaChange}
                        name={"concursoParticipa"}
                        label={"¿Participará en el concurso de tesis? *"}
                        options={[
                            {value:'Si', label:'Si'},
                            {value:'No', label:'No'},
                        ]}
                        paddingV={1}
                        paddingH={0}
                        value={concursoParticipa}
                        variant='outlined' 
                    />

                    <Grid 
                        container 
                        spacing={2} 
                        sx={{ 
                            display:(esConcursante) ? 'flex' : 'none', m: 1, p: 1, backgroundColor: 'whitesmoke' 
                        }}
                    >

                        {/* Categoria */}
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"concursoCategoria"}
                            label={"Categoria *"}
                            options={[
                                {value:'Licenciatura', label:'Licenciatura'},
                                {value:'Maestría', label:'Maestría'},
                                {value:'Doctorado', label:'Doctorado'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={concursoCategoria}
                            variant='outlined' 
                        />
                        <Grid item xs={12} >
                            <h6>Datos del asesor(a)</h6>
                        </Grid>
                        <GroupUserData parentCallback={handleInputChange}
                            title='' 
                            userEmail='concursoAsesorCorreo' 
                            userEmailLabel='Correo electrónico *' 
                            userFatherName='concursoAsesorApellidoPaterno' 
                            userFatherNameLabel='Apellido Paterno *' 
                            userMotherName='concursoAsesorApellidoMaterno' 
                            userMotherNameLabel='Apellido Materno' 
                            userName='concursoAsesorNombres' 
                            userNameLabel='Nombre(s) *' 
                            variant='outlined' 
                        />

                        {/* Institucion de procedencia */}
                        <Grid container spacing={2} sx={{ pt: 0, pb: 1, pl: 2, pr: 2 }}>
                            <Grid item xs={12} >
                                <TextField
                                    fullWidth
                                    id="concursoAsesorInstitucion"
                                    label={`Institución de procedencia *`}
                                    name="concursoAsesorInstitucion"
                                    size="small"
                                    // value={concursoAsesorInstitucion}
                                    onChange={handleInputChange}
                                    value={concursoAsesorInstitucion}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                        
                        {/* Telefono */}
                        <InputNumber
                            parentCallback={handleInputChange}
                            defaultValue={''}
                            inputProps={{ 
                                min: 1, 
                            }}
                            label={'Teléfono *'}
                            name={'concursoAsesorTelefono'}
                            paddingH={2}
                            paddingV={1}
                            value={concursoAsesorTelefono}
                            variant={'outlined'}
                            xs={6}
                        />

                        {/* Miembro SIMAC */}
                        <SelectCustom 
                            parentCallback={handleInputChange}
                            name={"concursoAsesorMiembro"}
                            label={"¿Miembro SIMAC? *"}
                            options={[
                                {value:'Si', label:'Si'},
                                {value:'No', label:'No'},
                            ]}
                            paddingV={1}
                            paddingH={2}
                            value={concursoAsesorMiembro}
                            variant='outlined' 
                        />
                        
                    </Grid>

                </Grid>


                <Divider sx={{ mt: 2 }}/>

                {/* Boton submit */}
                <Grid container >
                    <Grid item xs={4}>
                        <ButtonSubmit label={`Enviar`} />
                    </Grid>
                </Grid>

            </Box>

            {/* Dialogo 'enviando la informacion' */}
            <SendingDialog show={sendingForm} />
            
            {/* Dialogo de que ya no esta disponible el registro */}
            <CustomDialog 
                show={ false } 
                // show={ event.registroActivo !== '1' } 
                title={'¡Gracias por su interes!'} 
                content={'El registro de participantes ya no esta disponible.'} 
            >                
            </CustomDialog>
        </Box>


    );
};
